import { render, staticRenderFns } from "./EditImageDlg.vue?vue&type=template&id=18684dca"
import script from "./EditImageDlg.vue?vue&type=script&lang=ts"
export * from "./EditImageDlg.vue?vue&type=script&lang=ts"
import style0 from "./EditImageDlg.vue?vue&type=style&index=0&id=18684dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports